export default {
  getIncidencia (state) {
    if (state.incidencia && Object.keys(state.incidencia).length) {
      return state.incidencia
    } else {
      return Object.assign({
        Cliente: null,
        Instalacion: null,
        Incidencia: 0,
        FechaIncidencia: null,
        FechaCierreIncidencia: null,
        TiempoEmpleado: '00:00',
        Programa: null,
        TipoIncidencia: null,
        Prioridad: null,
        TecnicoRecepcion: null,
        TecnicoAsignado: null,
        ReportadaPor: '',
        Descripcion: '',
        ReferenciaIncidenciaCliente: '',
        Observaciones: '',
        Reaperturas: 0,
        NumeroModificacion: 0,
        DescontarHoras: false,
        IncidenciaSinMantenimiento: false,
        Estado: 'N',
        Presupuesto: '',
        Albaran: '',
        FechaProximoAviso: null,
        NotificableBoletin: false,
        TecnicosSeguimiento: null,
        Leida: false,
        IncidenciaPersonas: [],
        Trabajosrealizados: []
      })
    }
  },
  getEntity: (state) => (entity) => {
    return state[entity] || []
  },
  findBy: (state) => (params) => {
    if (!params) return 'No value'
    if (!params.entity || (!state[params.entity] || !state[params.entity].length)) {
      return params.id
    }

    let value = params.value || 'value'
    let label = params.label || ''
    let object = state[params.entity].find((x) => x[value] === params.id)
    return (object && label ? object[label] : object) || params.id
  },
  filterByIncludes: (state) => (params) => {
    if (!params || !params.entity || (!state[params.entity] || !state[params.entity].length)) {
      return []
    }

    let value = params.value || 'value'

    let object = state[params.entity].filter((x) => x[value].startsWith(params.id))
    return object || []
  }
}
